import * as React from 'react';
import { Route, Switch, withRouter } from 'react-router';

/* import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { updateBreadCrumbs } from 'src/redux/Actions/BreadCrumbs/ActionCreators';

import { IBreadcrumbItem, IconButton } from 'office-ui-fabric-react'; */
import { getTheme } from 'office-ui-fabric-react/lib/Styling';

import { Menu, Tab } from 'semantic-ui-react';
import SearchSimple from '../SearchSimple/SearchSimple';

import SearchResults from '../SearchResults/SearchResults';
import './Tabs.css';

import update from 'immutability-helper';
import { IconButton } from 'office-ui-fabric-react';
import * as queryString from 'query-string';

export interface ITabsState {
  tabs: any[];
  idx: number;
  activeIndex: number;
}

/* const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateBreadCrumbs: (items: IBreadcrumbItem[]) => dispatch(updateBreadCrumbs(items))
  };
}; */

class TabsSemanticHome extends React.PureComponent<any, ITabsState> {
  constructor(props: any) {
    super(props);

    this.state = {
      idx: 1,
      tabs: [],
      activeIndex: 0
    };

    this.openNewTab = this.openNewTab.bind(this);
    this.onTabChange = this.onTabChange.bind(this);
    this.onCloseTab = this.onCloseTab.bind(this);
    this.getTabIndex = this.getTabIndex.bind(this);
    this.getTabName = this.getTabName.bind(this);
  }

  public render(): JSX.Element {
    return (
      <Tab
        menu={{ color: 'orange', secondary: true, pointing: true }}
        panes={this.state.tabs}
        renderActiveOnly={false}
        onTabChange={this.onTabChange}
        activeIndex={this.state.activeIndex}
        style={{ height: '100%' }}
        className={'TabResults'}
      />
    );
  }

  public componentDidMount() {
    // const items: IBreadcrumbItem[] = [{ text: 'Home', key: '/home' }, { text: 'Search', key: '/search', isCurrentItem: true }];
    //  this.props.updateBreadCrumbs(items);

    this.openNewTab();
  }

  public componentDidUpdate() {
    this.openNewTab();
  }

  private openNewTab(): void {
    const { pathname, search } = this.props.location;
    const locKey: string = pathname + search;

    const activeTab = this.state.tabs.find(x => x.key === locKey);

    if (!activeTab) {
      const newTab = {
        key: locKey,
        menuItem: (
          <Menu.Item key={locKey}>
            {this.getTabName(this.props.location)}
            <IconButton
              iconProps={{ iconName: 'StatusCircleErrorX' }}
              styles={{
                root: { height: 'unset', padding: 0, width: '16px' },
                icon: { margin: 0, fontWeight: 'bold' },
                iconHovered: { color: getTheme().palette.themePrimary }
              }}
              // tslint:disable-next-line:jsx-no-lambda
              onClick={ev => this.onCloseTab(ev, locKey)}
            />
          </Menu.Item>
        ),
        pane: {
          className: 'noBorder',
          key: locKey,
          content: (
            <div style={{ height: '100%' }}>
              <Switch location={this.props.location}>
                <Route exact={true} path="/search/results" component={SearchSimple} />

                <Route exact={true} path="/search/template/:templateId(\d+)/results" component={SearchResults} />
              </Switch>
            </div>
          )
        }
      };

      const newTabs = update(this.state.tabs, { $push: [newTab] });

      this.setState({ idx: this.state.idx + 1, tabs: newTabs, activeIndex: newTabs.length - 1 });
    } else {
      this.setState({ activeIndex: this.getTabIndex(activeTab.key) });
    }
  }

  private getTabIndex(key: string): number {
    return this.state.tabs.findIndex(x => x.key === key);
  }

  private getTabName(location: any): string {
    const query = queryString.parse(this.props.location.search);
    if (location.pathname === '/search/results') {
      if (query.q) {
        return `${query.q}`;
      }
    } else {
      if (query.properties) {
        const props = query.properties as string;
        const parsedProps = JSON.parse(props);
        return `${parsedProps.name}`;
      }
      return 'Template Search';
    }
    return '';
  }

  private onCloseTab(event: React.MouseEvent<any>, key: string): void {
    event.stopPropagation();
    event.preventDefault();

    const index = this.getTabIndex(key);

    const newTabs = update(this.state.tabs, { $splice: [[index, 1]] });

    this.setState({ tabs: newTabs });

    if (newTabs.length === 0) {
      this.props.history.push('/search');
    } else if (this.state.activeIndex === index) {
      this.setState({ activeIndex: 0 });
      this.props.history.push(this.state.tabs[0].key);
    }
  }

  private onTabChange(ev: React.SyntheticEvent, data: any) {
    ev.stopPropagation();
    ev.preventDefault();

    this.props.history.push(this.state.tabs[data.activeIndex].key);
    this.setState({ activeIndex: data.activeIndex });
  }
}

/* export default withRouter(connect(
  null,
  mapDispatchToProps
)(TabsSemanticHome) as any); */

export default withRouter(TabsSemanticHome);
